import { createSlice } from '@reduxjs/toolkit'
import { getActiveFilters } from 'utils/helpers'

const initialState = {
  activeFilters: [] as string[],
  tableFilters: {
    search: '',
    student: '',
    condition_category: '',
    condition: '',
    reporter: '',
    created_at_from: '',
    created_at_to: ''
  },
}

export const medicalRecordsUI = createSlice({
  name: 'medicalRecordsUI',
  initialState: initialState,
  reducers: {
    setSearch: (state, { payload }) => {
      state.tableFilters.search = payload
    },
    setStudent: (state, { payload }) => {
      state.tableFilters.student = payload
    },
    setConditionCategory: (state, { payload }) => {
      state.tableFilters.condition_category = payload
    },
    setCondition: (state, { payload }) => {
      state.tableFilters.condition = payload
    },
    setReporter: (state, { payload }) => {
      state.tableFilters.reporter = payload
    },
    setCreatedAtFromDate: (state, { payload }) => {
      state.tableFilters.created_at_from = payload
    },
    setCreatedAtToDate: (state, { payload }) => {
      state.tableFilters.created_at_to = payload
    },
    trackActiveFilters: (state: any) => {
      state.activeFilters = getActiveFilters(initialState.tableFilters, state)
    },
    clearAllFilters: (state: any) => {
      state.tableFilters = initialState.tableFilters
      state.activeFilters = []
    },
  },
})

export const {
  setSearch,
  setStudent,
  setCondition,
  setConditionCategory,
  setReporter,
  setCreatedAtFromDate,
  setCreatedAtToDate,
  trackActiveFilters,
  clearAllFilters,
} = medicalRecordsUI.actions

export default medicalRecordsUI.reducer
